import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-react-data-grid', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 0,
});

cssRule('.tb-react-dg-hcell', {
    height: '37px',
    lineHeight: '37px',
    fontSize: '13px',
    fontWeight: 'bold',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-react-dg-hcell-sortable', {
    cursor: 'pointer',
});

cssRule('.tb-react-dg-hcell-sortable:hover', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
});

cssRule('.tb-react-dg-body', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-react-dg-bcell[role="gridcell"]', {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
});

cssRule('.tb-spaces-list-view .tb-react-dg-bcell', {
    paddingLeft: 0,
    paddingRight: 0,
});

cssRule('.tb-spaces-list-view .tb-react-dg-hrow', {
    border: 'none',
});

cssRule('.tb-spaces-list-view .tb-react-dg-hcell-resizable', {
    border: 'none',
});

cssRule('.tb-spaces-list-view .tb-favorite-button-cell .tb-favorite-button', {
    top: 'auto',
    left: 'auto',
});

